/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "af609fdab7bf050330de690b77fe1a75eba36829";
